import Phaser from "phaser";
import { SCALE } from "../../../utils/constants";
import UI from "../../UI";
import GameObject from "../GameObject";

export default class Explosion extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level,
    });
    this.power = 10;
    this.strength = 10;
  }

  setPosition(coords) {
    super.setPosition(coords);

    const explosion = this.level.scene.add
      .sprite(UI.tileToScreen(coords.x), UI.tileToScreen(coords.y))
      .setOrigin(0.125, 0.125)
      .play("explosion_explode")
      .setDepth(105);
    this.level.scene.events.emit('sounds:explosion')
    explosion.setScale(SCALE());

    this.level.scene.plugins.get("rexTintRGB").add(explosion, 0xffffff);
    explosion.tintGray = 128;
    explosion.tintR = 15;
    explosion.tintG = 75;
    explosion.tintB = 70;

    explosion.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      explosion.destroy();
    });
  }
}
